import Swiper, { Autoplay } from 'swiper';
import GLightbox from 'glightbox';

Swiper.use([Autoplay]);

const initSlider = () => {
  new Swiper('.carousel__slider .swiper', {
    loop: true,
    spaceBetween: 20,
    slidesPerView: 1,
    speed: 5000,
    loopedSlides: 10,
    freeMode: true,
    keyboard: false,
    pagination: false,
    navigation: false,
    allowTouchMove: false,
    preventClicks: true,
    preventClicksPropagation: true,
    simulateTouch: false,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },

    // navigation: {
    //   nextEl: '.carousel__next',
    //   prevEl: '.carousel__prev',
    // },

    // pagination: {
    //   el: '.complexes__pagination',
    //   clickable: true,
    // },

    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
};

const initZoom = () => {
  GLightbox({
    selector: '.carousel-1 .carousel__slide',
    loop: true,
  });

  GLightbox({
    selector: '.carousel-2 .carousel__slide',
    loop: true,
  });

  GLightbox({
    selector: '.carousel-3 .carousel__slide',
    loop: true,
  });
};

const carousel = {
  init: () => {
    initSlider();
    initZoom();
  },
};

export default carousel;
